import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "valueIsNumericString"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';
import { TextField } from '../text-field';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var NumberFormatInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var onChange = props.onChange,
    valueIsNumericString = props.valueIsNumericString,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(NumericFormat, _objectSpread(_objectSpread({}, other), {}, {
      customInput: TextField,
      getInputRef: ref,
      onValueChange: function onValueChange(values) {
        if (onChange && other.name) {
          var newValue = {
            target: {
              name: other.name,
              value: valueIsNumericString ? values.floatValue || values.value : values.formattedValue
            }
          };
          onChange(newValue);
        }
      }
    }))
  });
});
NumberFormatInput.displayName = 'NumberFormatInput';
export { NumberFormatInput };